import { computed, Injectable, signal } from '@angular/core';

type Theme = 'light' | 'dark';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly _$theme = signal<Theme>('light');

  $theme = this._$theme.asReadonly();

  $isDarkTheme = computed(() => this.$theme() === 'dark');
  toggleTheme() {
    this._$theme.set(this.$theme() === 'light' ? 'dark' : 'light');
  }

  setTheme(theme: Theme) {
    this._$theme.set(theme);
  }
}
